/* ACC_YGH_LP_01 — shared progressive enhancements.
   Pure CSS handles the FAQ animation and plus-icon rotation; this only
   adds the "single open at a time" behaviour and the stock-bar reveal.
   Guarded so it runs once even if loaded by multiple sections. */
(function () {
  if (window.__accYghLp01Init) return;
  window.__accYghLp01Init = true;

  function init() {
    /* FAQ: smooth slide open/close in both directions. Items toggle
       independently (multiple can stay open). Native <details> can't animate
       on close, so we drive the height and defer the open-attribute change. */
    document.querySelectorAll('.acc-faq__item').forEach(function (item) {
      var summary = item.querySelector('summary');
      var answer = item.querySelector('.acc-faq__answer');
      if (!summary || !answer) return;

      answer.style.height = item.open ? 'auto' : '0px';

      summary.addEventListener('click', function (e) {
        e.preventDefault();
        if (item.dataset.animating) return;
        item.dataset.animating = '1';

        if (item.open) {
          // close: lock current height, then collapse to 0
          answer.style.height = answer.scrollHeight + 'px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { answer.style.height = '0px'; });
          });
          answer.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', te);
            item.open = false;
            delete item.dataset.animating;
          });
        } else {
          // open: render content, then expand from 0 to its natural height
          item.open = true;
          answer.style.height = '0px';
          requestAnimationFrame(function () {
            requestAnimationFrame(function () { answer.style.height = answer.scrollHeight + 'px'; });
          });
          answer.addEventListener('transitionend', function te(ev) {
            if (ev.propertyName !== 'height') return;
            answer.removeEventListener('transitionend', te);
            answer.style.height = 'auto';
            delete item.dataset.animating;
          });
        }
      });
    });

    /* Stock-urgency: animate the progress bar fill when scrolled into view */
    var bars = document.querySelectorAll('.acc-urgency');
    if (bars.length) {
      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-visible');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.35 });
        bars.forEach(function (b) { io.observe(b); });
      } else {
        bars.forEach(function (b) { b.classList.add('is-visible'); });
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
